import { ContentWithAside } from "layouts/kiosk-h"
import { MovieShowTimeKioskHPage } from "./pages/movie-show-time/index.kiosk"
import { MovieDetailKioskHPage } from "./pages/movie-show-time/movie/[movieId]/cinema/[cinemaCode]/index.kiosk"
import { themeOptionFactories } from "./theme"

export const movieShowTime = {
  themeOptionFactories,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [],
    "kiosk-v": [],
    "kiosk-h": [
      {
        path: "movie",
        element: <MovieShowTimeKioskHPage Layout={ContentWithAside} />,
      },
      {
        path: "movie/:movieId/cinema/:cinemaCode",
        element: <MovieDetailKioskHPage Layout={ContentWithAside} />,
      },
    ],
  },
}
